/** Badge — status & meta tags. */
import { cn } from "../../lib/cn";

const variants = {
  default: "bg-surface-2 text-text border-line-2",
  primary: "bg-plum/15 text-mauve border-plum/30",
  success: "bg-sage/15 text-sage border-sage/40",
  warning: "bg-gold/15 text-gold border-gold/40",
  danger: "bg-red-500/12 text-red-300 border-red-500/30",
  info: "bg-mauve/12 text-mauve border-mauve/30",
  muted: "bg-transparent text-text-faint border-line",
  gold: "bg-gold/12 text-gold border-gold/40",
};

const sizes = {
  sm: "text-[10.5px] px-2 py-0.5",
  default: "text-[11px] px-2.5 py-1",
  lg: "text-[12px] px-3 py-1.5",
};

export function Badge({ className, variant = "default", size = "default", children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-mono uppercase tracking-[0.14em] border whitespace-nowrap",
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}

// Pre-built status badges for content states (used in CMS/admin later)
export const StatusBadges = {
  Draft: (p) => <Badge variant="muted" {...p}>Draft</Badge>,
  Published: (p) => <Badge variant="success" {...p}>Published</Badge>,
  Archived: (p) => <Badge variant="muted" {...p}>Archived</Badge>,
  Pending: (p) => <Badge variant="warning" {...p}>Pending</Badge>,
  Review: (p) => <Badge variant="info" {...p}>In Review</Badge>,
  Featured: (p) => <Badge variant="primary" {...p}>Featured</Badge>,
  New: (p) => <Badge variant="info" {...p}>New</Badge>,
  Bestseller: (p) => <Badge variant="gold" {...p}>Bestseller</Badge>,
  Verified: (p) => <Badge variant="success" {...p}>Verified</Badge>,
  Premium: (p) => <Badge variant="gold" {...p}>Premium</Badge>,
};
